import {
	container,
	description,
	cardTitle,
	blackColor,
	whiteColor,
	grayColor,
	hexToRgb,
} from "assets/jss/material-kit-pro-react.js";

const signupPageStyle = (theme) => ({
	description,
	cardTitle: {
		...cardTitle,
		color: whiteColor + "  !important",
		fontSize: "1.5em",
	},
	container: {
		...container,
		zIndex: "4",
		[theme.breakpoints.down("sm")]: {
			paddingBottom: "100px",
		},
	},
	pageHeader: {
		color: whiteColor,
		border: "0",
		height: "100%",
		margin: "0",
		display: "flex!important",
		padding: "120px 0",
		position: "relative",
		minHeight: "100vh",
		alignItems: "center",
		"&:before": {
			background: "rgba(" + hexToRgb(blackColor) + ", 0.5)",
		},
		"&:before,&:after": {
			position: "absolute",
			zIndex: "1",
			width: "100%",
			height: "100%",
			display: "block",
			left: "0",
			top: "0",
			content: '""',
		},
	},
	form: {
		margin: "0",
	},
	cardHeader: {
		width: "auto",
		textAlign: "center",
	},
	socialLine: {
		marginTop: "1rem",
		textAlign: "center",
		padding: "0",
	},
	inputIconsColor: {
		color: grayColor[13],
	},
	textCenter: {
		textAlign: "center",
	},
	textRight: {
		textAlign: "right",
	},
	textLeft: {
		textAlign: "left",
	},
	labelTitle: {
		fontSize: "1rem",
		fontWeight: "800",
		color: "#444",
	},
	iconButtons: {
		marginRight: "3px !important",
		marginLeft: "3px !important",
	},
	block: {
		color: "inherit",
		padding: "0.9375rem",
		fontWeight: "500",
		fontSize: "12px",
		textTransform: "uppercase",
		borderRadius: "3px",
		textDecoration: "none",
		position: "relative",
		display: "block",
	},
	inlineBlock: {
		display: "inline-block",
		padding: "0px",
		width: "auto",
	},
	list: {
		marginBottom: "0",
		padding: "0",
		marginTop: "0",
	},
	left: {
		float: "left!important",
		display: "block",
		"&,& *,& *:hover,& *:focus": {
			color: whiteColor + "  !important",
		},
	},
	right: {
		padding: "15px 0",
		margin: "0",
		float: "right",
		"&,& *,& *:hover,& *:focus": {
			color: whiteColor + "  !important",
		},
	},
	icon: {
		width: "18px",
		height: "18px",
		top: "3px",
		position: "relative",
	},
	footer: {
		position: "absolute",
		width: "100%",
		background: "transparent",
		bottom: "0",
		color: whiteColor,
		zIndex: "2",
	},
	loading: {
		opacity: "0.4",
	},
	cartLabel: {
		fontFamily: "Rubik-Medium",
		fontSize: "16px",
		transition: "0.3s ease all",
		lineHeight: "1.428571429",
		fontWeight: "500",
		paddingLeft: "0",
	},
	buttonPrimary: {
		marginTop: "5px",
		marginBottom: "5px",
		fontSize: "0.6875rem",
		borderRadius: "0.2rem",
		textTransform: "uppercase",
		lineHeight: "1.5",
		fontFamily: "Rubik-Medium",
		fontWeight: "400",
		padding: "0.40625rem 1.25rem",
		fontWeight: "500",
		verticalAlign: "middle",
		backgroundColor: "#ffffff",
		borderColor: "#072A40",
		color: "#072A40",
		border: "1px solid #072A40",
		transition: "all 0.1s ease",
		cursor: "pointer",
		marginRight: "10px",
		"&:hover": {
			backgroundColor: "#072A40",
			color: "#ffffff",
			border: "1px solid #072A40",
			transition: "all 0.4s ease",
			boxShadow:
				"0 1px 1px 0 #072A40, 0 2px 1px -2px #072A40, 0 1px 2px 0 #072A40",
		},
		"&:disabled": {
			backgroundColor: "#072A40",
			color: "#ffffff",
			border: "1px solid #072A40",
			opacity: "0.5",
		},
	},
});

export default signupPageStyle;
